export default __webpack_public_path__ + "static/media/distillation2.487e0126.jpg";